export default "__VITE_ASSET__qxmdfD1P__"